"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpectedValueChip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const react_1 = require("react");
const expected_values_options_1 = require("../../shared/expected-values-options");
const ExpectedValueChip = ({ expectedValueType, editable, onEdit, onDelete, ...props }) => {
    const [hovered, setHovered] = (0, react_1.useState)(false);
    const { icon, title, colors } = expected_values_options_1.expectedValuesOptions[expectedValueType];
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { width: 1, direction: "row", onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), children: (0, jsx_runtime_1.jsx)(design_system_1.Chip, { ...props, label: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "smallTextLabels", sx: {
                            display: "flex",
                            alignItems: "center",
                            color: colors.textColor,
                            py: 0.25,
                            pr: hovered ? 0.75 : 1.5,
                            transition: ({ transitions }) => transitions.create("padding-right"),
                        }, children: [(0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: {
                                    icon,
                                }, sx: { fontSize: "1em", mr: "1ch" } }), title] }), (0, jsx_runtime_1.jsx)(material_1.Collapse, { orientation: "horizontal", in: hovered, children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", height: 1, children: [editable ? ((0, jsx_runtime_1.jsx)(design_system_1.IconButton, { onClick: onEdit, sx: {
                                        p: 0,
                                        mr: 1,
                                        color: colors.textColor,
                                        ":hover": {
                                            backgroundColor: "transparent",
                                            color: colors.hoveredButtonColor,
                                        },
                                    }, children: (0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faEdit, sx: {
                                            fontSize: "13px !important",
                                        } }) })) : null, (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        pl: 0.75,
                                        pr: 1,
                                        backgroundColor: ({ palette }) => palette.gray[10],
                                    }, children: (0, jsx_runtime_1.jsx)(design_system_1.IconButton, { onClick: onDelete, sx: {
                                            p: 0,
                                            ":hover": {
                                                backgroundColor: "transparent",
                                            },
                                        }, children: (0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faClose, sx: {
                                                fontSize: "13px !important",
                                            } }) }) })] }) })] }), onDelete: undefined, sx: {
                position: "relative",
                backgroundColor: colors.backgroundColor,
                overflow: "hidden",
                [`.${material_1.chipClasses.deleteIcon}`]: {
                    color: colors.textColor,
                },
                [`.${material_1.chipClasses.label}`]: {
                    p: 0,
                    pl: 1.5,
                },
            } }) }));
};
exports.ExpectedValueChip = ExpectedValueChip;
